<template>
  <div v-if="cardTitle" @click="$emit('click')" class="single-entity-card-wrapper">
    <div class="single-card-title">{{ this.cardTitle }}</div>
    <div class="entity-card-date">{{ date }}</div>
  </div>
</template>

<script>
export default {
  name: 'EntityCard',
  props: {
    cardTitle: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    details: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.single-entity-card-wrapper {
  padding: 12px;
  margin: 16px 0;
  background: #ffffff;
  border: 1px solid #C9CBD5;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
}

.entity-card-body {
  display: flex;
  flex-direction: row;
}

.single-card-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  cursor: pointer;
}

.single-card-title:hover {
  text-decoration: underline;
}

.entity-card-date {
  color: #565963;
  font-size: 16px;
  width: 100px;
}
</style>
